import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AfDatepickerDirective } from './directives/af-datepicker.directive';
import { ResizableModule } from './directives/af-Resizable';
import { NgbdSortableHeader } from './directives/sortable.directive';
import { AfImageDirective } from './directives/af-image.directive';
import { AuthGuardService } from './services/auth-guard.service';
import { BaseService } from './services/base.service';
import { DataService } from './services/data.service';
import { EncryptionService } from './services/encryption.service';
import { UploadDocumentComponent } from './views/UploadDocument/upload-document/upload-document.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageSafePipe } from './pipes/safe.pipe';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomLoader } from './common-services/custom-loader.service';
import { LanguageDataService } from './common-services/language-data.service';
import { ViewUploadedDocumentComponent } from './views/UploadDocument/view-uploaded-document/view-uploaded-document.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TextareaAutoresizeDirective } from './directives/textarea-autoresize.directive';


export function createTranslateLoader(commonLocalizationService: LanguageDataService) {
  return new CustomLoader(commonLocalizationService);
}
@NgModule({
  declarations: [
    AppComponent,
    AfDatepickerDirective,
    NgbdSortableHeader,
    AfImageDirective,
    UploadDocumentComponent,
    ImageSafePipe,
    ViewUploadedDocumentComponent,
    TextareaAutoresizeDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ResizableModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    FormsModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [LanguageDataService]
      }
    }),
  ],
  providers: [AuthGuardService],
  bootstrap: [AppComponent],
  exports: [AfDatepickerDirective,NgbdSortableHeader,AfImageDirective,ImageSafePipe,TextareaAutoresizeDirective]
})
export class AppModule { }
export class AutofacetsCoreModule {
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers: [
        BaseService,
        DataService,
        EncryptionService,
        AuthGuardService,
        TranslateService
      ]
    };
  }
}
